<template>
  <div class="approvalWarp">
    <Tabs class="customTabs block" v-model="activeNamTab" name="navTab">
      <TabPane :label="baseInfoLabel" name="baseInfo" tab="navTab">
        <BaseInfo ref="baseInfoRef" :type="baseInfoType" :id="currentId" />
      </TabPane>
      <TabPane
        :label="formDesignLabel"
        name="formDesign"
        tab="navTab"
        :disabled="baseInfoType != 'edit'"
      >
        <FormDesign
          ref="formDesignRef"
          :type="formDesignType"
          :id="currentId"
          :conditionsUseing="conditionsUseing"
          @on-created="getFormDetailcomplete"
        />
      </TabPane>
      <TabPane
        :label="processDesignLabel"
        name="processDesign"
        tab="navTab"
        :disabled="formDesignType != 'edit'"
      >
        <Workflow
          ref="processDesignRef"
          :id="currentId"
          :permisionOption="permisionOption"
          :type="processDesignType"
          @on-created="getProcessDesigncomplete"
        />
      </TabPane>
      <TabPane
        :label="advancedSettingsLabel"
        name="advancedSettings"
        tab="navTab"
        :disabled="processDesignType != 'edit'"
      >
        <AdvancedSettings
          ref="advancedSettingRef"
          :type="advancedSettingsType"
          :id="currentId"
        />
      </TabPane>
      <div slot="extra">
        <Button
          v-if="
            ['baseInfo', 'formDesign', 'processDesign'].includes(activeNamTab)
          "
          class="saveAndNext"
          @click="saveAndNext"
        >
          保存&下一步
        </Button>
        <Button v-else @click="submit" type="primary">发布</Button>
      </div>
    </Tabs>
  </div>
</template>
<script>
import { BaseInfo, FormDesign, AdvancedSettings, Workflow } from './components';
import { tabNameMap } from './config';
import { enableStatus, disableStatus } from '@/api/tempApprovalManage';
export default {
  components: { BaseInfo, FormDesign, AdvancedSettings, Workflow },
  data() {
    return {
      baseInfoLabel: '',
      formDesignLabel: '',
      processDesignLabel: '',
      advancedSettingsLabel: '',
      activeNamTab: 'baseInfo',
      tabsList: ['baseInfo', 'formDesign', 'processDesign', 'advancedSettings'],
      type: 'create',
      baseInfoType: 'create',
      formDesignType: 'create',
      processDesignType: 'create',
      advancedSettingsType: 'create',
      currentId: '',
      permisionOption: [],
      currentStatus: 0,
      conditionsUseing: [] // 表单不能删除的空间id
    };
  },
  methods: {
    async submit() {
      const advancedRes = await this.saveAdvancedSettings();
      if (advancedRes) {
        const checkoutStatusMethods =
          this.currentStatus == 1 ? enableStatus : disableStatus;
        const res = await checkoutStatusMethods(this.currentId);
        const { code } = res.data;
        if (code == 200) {
          this.$router.push('/tplApprovalManage');
        }
      }
    },
    nextStep() {
      const currentTab = this.activeNamTab;
      let currentStep = this.tabsList.indexOf(currentTab);
      currentStep++;
      const nextTab = this.tabsList[currentStep];
      this.activeNamTab = nextTab;
    },
    async saveAndNext() {
      const { submitName } = tabNameMap[this.activeNamTab];
      const res = await this[submitName]();
      if (res) {
        this.nextStep();
      }
    },
    // 保存基本信息
    saveBaseInfo() {
      return new Promise(resolve => {
        const baseInfo = this.$refs.baseInfoRef;
        baseInfo.submitBaseInfo(this.currentId).then(res => {
          if (this.baseInfoType == 'create') {
            this.currentId = res;
          }
          this.baseInfoType = 'edit';
          resolve(true);
        });
      });
    },
    // 保存表单设计
    saveFormDesign() {
      return new Promise(resolve => {
        const formDesignDom = this.$refs['formDesignRef'];
        formDesignDom.submitFormDesign(this.currentId).then(res => {
          if (res) {
            this.formDesignType = 'edit';
            this.permisionOption = res;
            resolve(true);
          }
        });
      });
    },
    // 保存流程设计
    saveProcessDesign() {
      return new Promise(resolve => {
        const processDesignDom = this.$refs.processDesignRef;
        processDesignDom.submitWorkflow(this.currentId).then(res => {
          if (res) {
            this.conditionsUseing = res;
            this.processDesignType = 'edit';
            resolve(true);
          }
        });
      });
    },
    // 保存高级设置
    saveAdvancedSettings() {
      return new Promise(resolve => {
        const advancedSettingDom = this.$refs.advancedSettingRef;
        advancedSettingDom.submitAdvanced(this.currentId).then(res => {
          if (res) {
            this.advancedSettingsType = 'edit';
            resolve(true);
          }
        });
      });
    },
    init() {
      // 1 基础设置
      this.baseInfoLabel = this.getLabel('1 基础设置', 'baseInfo');
      // 2 表单设计
      this.formDesignLabel = this.getLabel('2 表单设计', 'formDesign');
      // 3 流程设计
      this.processDesignLabel = this.getLabel('3 流程设计', 'processDesign');
      // 4 高级设置
      this.advancedSettingsLabel = this.getLabel(
        '4 高级设置',
        'advancedSettings'
      );
      const { type = 'create', id, status = 0 } = this.$route.query;
      this.type = type;
      this.baseInfoType = type;
      this.formDesignType = type;
      this.processDesignType = type;
      this.advancedSettingsType = type;
      this.currentStatus = status;
      if (type == 'edit') {
        this.currentId = id;
      }
    },
    tabClick(name) {
      const that = this;
      const beforeTagName = this.activeNamTab;
      if (beforeTagName == name) return false;
      const { changeTabMessage: content = '' } = tabNameMap[beforeTagName];
      this.$Modal.confirm({
        title: '提示',
        content,
        okText: '保存并继续',
        cancelText: '不保存',
        onOk() {
          // 保存，调用一下保存的接口
          that.saveData(beforeTagName).then(res => {
            if (res) {
              that.activeNamTab = name;
            }
          });
        },
        onCancel() {
          // 取消的时候调用一下获取详情的接口
          that.getResetCurrentTagData(beforeTagName).then(res => {
            if (res) {
              that.activeNamTab = name;
            }
          });
        }
      });
    },
    saveData(beforeName) {
      return new Promise(resolve => {
        const { submitName } = tabNameMap[beforeName];
        this[submitName]().then(res => {
          if (res) {
            resolve(true);
          }
        });
      });
    },
    getResetCurrentTagData(beforeName) {
      return new Promise(resolve => {
        const { refName } = tabNameMap[beforeName];
        const currentDom = this.$refs[refName];
        currentDom.getDetail();
        resolve(true);
      });
    },
    getLabel(label, name) {
      const that = this;
      return h =>
        h(
          'div',
          {
            style: {
              padding: '8px 16px'
            },
            on: {
              click: e => {
                e.stopPropagation();
                that.tabClick(name);
              }
            }
          },
          label
        );
    },
    getFormDetailcomplete(data) {
      this.permisionOption = data;
    },
    getProcessDesigncomplete(data) {
      this.conditionsUseing = data;
    }
  },
  created() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
.customTabs {
  height: 100%;
  /deep/ .ivu-tabs-content {
    height: calc(~'100% - 52px');
  }
}
.customTabs /deep/ .ivu-tabs-bar .ivu-tabs-nav-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.approvalWarp {
  height: 100%;
}
.saveAndNext {
  margin-right: 5px;
}

/deep/
  .block
  > .ivu-tabs-bar
  > .ivu-tabs-nav-container
  > .ivu-tabs-nav-wrap
  > .ivu-tabs-nav-scroll
  > .ivu-tabs-nav
  > .ivu-tabs-tab {
  padding: 0;
}
</style>
